import React from 'react';
import styled from 'styled-components'

const CompanyBox = (props) => {

    return(
        <Box selected={props.selected}>
            <div class="asset-title">
                <label>{props.name.toUpperCase()}</label>

                {
                    props?.showDeleteCompany &&
                    <div class="btn-actions">
                        <i onClick={() => props.deleteCompany(props.company)} class="far fa-trash-alt"></i>
                    </div>
                }
            </div>
            <div class="asset-data">
                <span class="sub-title">MEMBERS</span><br/>
                <span class="value">{props.users ? props.users : "N/A"}</span>
            </div>
            <div class="asset-data">
                <span class="sub-title">SENSORS</span><br/>
                <span class="value">{props.sensors ? props.sensors :  "N/A"}</span>
            </div>
        </Box>
    )

}

export default CompanyBox;


const Box = styled.div`
  
  height:90px;
  display:flex;
  flex-flow: row wrap;
  align-items:center;
  padding:3px 0px;
  border-bottom:1px solid rgb(221, 222, 225);
  border-left: ${props => props.selected? "15px solid #58b8af" : "8px solid #58b8af"};
  background-color: ${props => props.selected? "#FAFAFA" : "#eeeeee"};

   :hover{
        background-color:#ddf0fd;
        cursor:pointer;

        .btn-actions{
            visibility: visible !important;
        }

   }
  

    .asset-title{
        flex: 1 1 auto;
        display: flex;

        font-size:14px;
        font-weight:bold;
        width:100%;
        padding:0px 5px;
        color:#37a3ef;

        label{
            flex: 1;
        }

        .btn-actions{
            visibility: hidden;
            margin-right: 10px;

            .fa-trash-alt{
                color: #D9534F;
            }
        }
    }
    .asset-data{
        padding:0px 5px;
        font-size:12px;
        flex:1 1 auto;
        border-left:1px solid rgb(221, 222, 225);
        color: rgb(134, 134, 149);

        .sub-title{
            font-weight:bold;

        }

    }
`


